import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router);

// 解决vue-router在3.0版本以上重复点菜单报错问题
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

const routes = [
    {path: '*', redirect: '/home' },
    {name: 'auth', component: () => import('./pages/auth'), meta: { title: '授权登录'}},
    {name: 'home/old', component: () => import('./pages/home'), meta: { title: '品致生活服务'}},
    {name: 'home', component: () => import('./pages/home/new'), meta: { title: '品致生活服务'}},
    {name: 'telnet', component: () => import('./pages/home/telnet'), meta: {title: '电信业务专区'}},
    //服务相关
    {name: 'cate', component: () => import('./pages/cate'), meta: {title: '服务详情'}},
    {name: 'cart', component: () => import('./pages/cart'), meta: {title: '购物车'}},
    {name: 'service', component: () => import('./pages/service'), meta: {title: '预约服务'}},
    {name: 'service/show', component: () => import('./pages/service/show'), meta: {title: '服务详情'}},
    {name: 'service/detail', component: () => import('./pages/service/detail'), meta: {title: '服务详情'}},

    //用户相关路由
    {name: 'user', component: () => import('./pages/user'), meta: {title: '会员权益'}},
    {name: 'user/order', component: () => import('./pages/user/order'), meta: {title: '我的订单'}},
    {name: 'user/point', component: () => import('./pages/user/point'), meta: {title: '我的积分'}},
    {name: 'user/profile', component: () => import('./pages/user/profile'), meta: {title: '个人资料'}},
    {name: 'user/mobile', component: () => import('./pages/user/mobile'), meta: {title: '绑定手机'}},
    {name: 'user/telnet', component: () => import('./pages/user/telnet'), meta: {title: '绑定电信账号'}},
    {name: 'user/vip', component: () => import('./pages/user/vip'), meta: {title: '我的VIP'}},
    {name: 'user/complain', component: () => import('./pages/user/complain'), meta: {title: '投诉订单'}},
    //地址组件
    {name: 'address', component: () => import('./pages/address'), meta: {title: '服务地址'}},
    {name: 'address/edit', component: () => import('./pages/address/edit'), meta: {title: '编辑服务地址'}},
    //订单类
    {name: 'order/create', component: () => import('./pages/order/create'), meta: {title: '订单提交'}},
    {name: 'order/show', component: () => import('./pages/order'), meta: {title: '订单详情'}},
    {name: 'order/edit', component: () => import('./pages/order/edit'), meta: {title: '订单更改'}},
    {name: 'order/payment', component: () => import('./pages/order/payment'), meta: {title: '订单支付'}},
    {name: 'order/exchange', component: () => import('./pages/order/exchange'), meta: {title: '礼包码兑换下单'}},

    {name: 'coupon', component: () => import('./pages/coupon'), meta: {title: '我的优惠券'}},
    {name: 'draw', component: () => import('./pages/draw'), meta: { title: '幸运大抽奖，惊喜赢好礼'}},
    {name: 'nov', component: () => import('./pages/nov'), meta: { title: '幸运大抽奖，惊喜赢好礼'}},
    {name: 'item', component: () => import('./pages/item'), meta: { title: '年末钜惠保洁福利大派送'}},
    {name: 'draw/act', component: () => import('./pages/draw/act'), meta: { title: '新年拆红包，惊喜赢好礼'}},
    {name: 'coupon/take', component: () => import('./pages/coupon/take'), meta: {title: '领优惠券'}},

    {name: 'group', component: () => import('./pages/group'), meta: {title: '拼单购买实惠多多！'}},
    {name: 'bargain', component: () => import('./pages/bargain'), meta: {title: '砍砍价实惠多多'}},
    {name: 'bargain/show', component: () => import('./pages/bargain/show'), meta: {title: '砍砍价实惠多多'}},
    {name: 'recharge', component: () => import('./pages/recharge'), meta: {title: '充值中心'}},
    //农行相关
    {name: 'abc', component: () => import('./pages/abc'), meta: { title: '品致生活服务'}},
    {name: 'abc/list', component: () => import('./pages/abc/list'), meta: { title: '品致生活服务'}},
    {name: 'abc/draw', component: () => import('./pages/abc/draw'), meta: {title: '全民狂欢大抽奖'}},
    {name: 'abc/group', component: () => import('./pages/abc/group'), meta: {title: '拼单购买实惠多多！'}},

    //代理商相关
    {name: 'agent', component: () => import('./pages/agent/home'), meta: {title: '推广订单'}},
    // {name: 'agent/home', component: () => import('./pages/agent/home'), meta: {title: '推广订单'}},
    {name: 'agent/collect', component: () => import('./pages/agent/collect'), meta: {title: '业务意向单登记'}},
    {name: 'agent/profile', component: () => import('./pages/agent/profile'), meta: {title: '我的资料'}},
    {name: 'agent/commission', component: () => import('./pages/agent/commission'), meta: {title: '佣金管理'}},
    {name: 'agent/profit', component: () => import('./pages/agent/profit'), meta: {title: '我的收益&提现记录'}},
    {name: 'agent/follow', component: () => import('./pages/agent/follow'), meta: {title: '合作商入驻'}},
    {name: 'agent/needs', component: () => import('./pages/agent/needs'), meta: {title: '便民服务信息登记'}},

    //电信代理佣金管理
    {name: 'dx', component: () => import('./pages/dx'), meta: {title: '佣金管理'}},
    {name: 'dx/profit', component: () => import('./pages/dx/profit'), meta: {title: '收益&提现记录'}},

    //家政服务专区
    {name: 'house', component: () => import('./pages/house'), meta: {title: '家政服务专区'}},
    //优惠专区
    {name: 'section', component: () => import('./pages/section'), meta: {title: '优惠专区'}},
    //快捷下单入口
    {name: 'short', component: () => import('./pages/short'), meta: {title: '品致生活服务'}},
    {name: 'short/dx', component: () => import('./pages/short/dx'), meta: {title: '品致生活服务'}},

    //活动页面
    {name: 'act', component: () => import('./pages/act'), meta: {title: '双11狂欢'}},
    //活动页面
    {name: 'act/new', component: () => import('./pages/act/new'), meta: {title: '家政服务'}},

    //生鲜水果
    {name: 'fruit', component: () => import('./pages/fruit'), meta: {title: '崀山红脐橙特卖专区'}},
    {name: 'fruit/show', component: () => import('./pages/fruit/show'), meta: {title: '崀山红脐橙特卖专区'}},
    {name: 'fruit/create', component: () => import('./pages/fruit/create'), meta: {title: '确认订单'}},
    {name: 'fruit/cart', component: () => import('./pages/fruit/cart'), meta: {title: '我的购物车'}},
    {name: 'fruit/order', component: () => import('./pages/fruit/order'), meta: {title: '订单详情'}},
    {name: 'fruit/olist', component: () => import('./pages/fruit/olist'), meta: {title: '我的订单'}},

    //金牌服务登记页面
    {name: 'sign', component: () => import('./pages/sign'), meta: {title: '金牌服务'}},
    {name: 'sign/dx', component: () => import('./pages/sign/dx'), meta: {title: '电信业务日'}},

    //拥军优属登记页面
    {name: 'yongjun', component: () => import('./pages/yongjun'), meta: {title: '崇军特惠'}},

    {name: 'news', component: () => import('./pages/news'), meta: {title: '品致生活资讯'}},
    //团预览页面
    {name: 'group/pre', component: () => import('./pages/group/pre'), meta: {title: '品致生活团购'}},

    {name: 'engineer', component: () => import('./pages/engineer'), meta: {title: '服务人员信息'}},
];

// add route path
routes.forEach(route => {
    route.path = route.path || '/' + (route.name || '');
});

const router = new Router({ 
    mode: 'history',
    routes: routes 
});

router.beforeEach((to, from, next) => {
    const title = to.meta && to.meta.title;
    if (title) {
        document.title = title;
    }

    var agent = navigator.userAgent.toLowerCase()
    var weixin = -1 != agent.indexOf("micromessenger")
    var next_path = '/auth'
    //充值专区在农行页面上也会用到，这个得定制化需求
    if (to.name == 'recharge') {
        next_path = weixin ? next_path : '/abc'
    }
    //农行专区页面
    var nh = ['abc/list', 'abc/draw']
    if (nh.indexOf(to.name) !== -1) {
        next_path = '/abc'
    }

    //当路由名不在数组内，则需要验证登录
    var ignore = ['auth', 'abc']
    if (ignore.indexOf(to.name) === -1) {
        var access_token = localStorage.getItem('wechat_access_token')
        var env = process.env.NODE_ENV
        //当前环境为正式环境并且不存在access_token时去授权登录页
        if (env == 'production' && !access_token) {
            localStorage.setItem('beforeUrl', to.fullPath)
            next(next_path)
            return 
        }
    }
  
    var u = navigator.userAgent;
    var iOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    if (iOS && to.path !== location.pathname) {
        // 此处不可使用location.replace
        location.assign(to.fullPath)
    } else {
        next()
    }
    // next()
});

export {
  router
};



// WEBPACK FOOTER //
// ./src/router.js